<template>
	<div class="drop-position" :style="concludeWH" ref="config">
		<vue-drag-resize
			class="mark-out-position"
			v-for="(rectItem, rectIndex) in rectDetail"
			:key="rectIndex"
			:x="rectItem.areaMinX"
			:y="rectItem.areaMinY"
			:w="operateWidth(rectItem)"
			:h="operateHeight(rectItem)"
			:isActive="rectIndex === tempActiveArea"
			:isDraggable="rectIndex === tempActiveArea"
			:isResizable="rectIndex === tempActiveArea"
			@click.native="exitDrag"
			@resizestop="rectDragResize($event, rectIndex)"
			@dragstop="rectDragResize($event, rectIndex)"
			@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY)"
		>
			<template>
				<div
					v-if="!rectItem.isShowChild"
					class="rect-title-wrap"
					@mousedown="addRect($event, rectItem, rectIndex, rectItem.areaMinX, rectItem.areaMinY)"
				>
					<div
						class="mark-list"
						v-for="(item, index) in JSON.parse(rectItem.appendInfo).box"
						v-show="JSON.parse(rectItem.appendInfo).box && JSON.parse(rectItem.appendInfo).box.length > 0"
						:key="`${rectIndex}-${index}`"
						:style="{
							top: `${item.y}px`,
							left: `${item.x}px`,
							width: `${item.w}px`,
							height: `${item.h}px`
						}"
						@mousedown="fixRectList($event, rectItem, item, rectIndex, index)"
					>
						<span class="mark-val" @mousedown="fixRectList($event, rectItem, item, rectIndex, index)">{{ item.v }}</span>
					</div>
					<i
						v-show="JSON.parse(rectItem.remarks).version"
						class="iconfont iconlajitong1 del-icon"
						@click="dropArea({ val: rectItem, state: true })"
					></i>
					<div class="drop-menu" v-show="JSON.parse(rectItem.remarks).version">
						<el-dropdown class="el-dropdown-link" @command="dropDownMenu($event, { val: rectItem, curIndex: rectIndex })">
							<i class="iconfont iconjiantou-down "></i>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="drag">拖拽选区</el-dropdown-item>
								<el-dropdown-item command="del">删除选区</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</template>
		</vue-drag-resize>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import isDragResize from '@/views/template-configuration/utils/mixin/is-drag-resize'
import drawRect from '@/views/template-configuration/utils/mixin/draw-rect'
import fixWH from '@/views/template-configuration/utils/mixin/fix-wh'
import fixRect from '@/views/template-configuration/utils/mixin/fix-rect'
import VueDragResize from 'vue-drag-resize'
export default {
	name: 'temp-lack',
	mixins: [isDragResize, drawRect, fixWH, fixRect],
	components: {
		VueDragResize
	},
	data() {
		return {
			//所有框子
			rectDetail: [],
			//type
			emitType: 'tempLack'
		}
	},
	watch: {
		// 缺考的数据
		typeLack: {
			handler(val) {
				this.opeCurLack(val)
			},
			immediate: true,
			deep: true
		},
		// 缺考的数据
		tempCurrentImgIndex() {
			this.opeCurLack(this.typeLack)
		}
	},
	computed: { ...mapGetters('examination/configation', ['typeLack', 'tempCurrentImgIndex']) },
	methods: {
		//获取当前页的缺考框子
		opeCurLack(val) {
			let resArr = []
			val.forEach(res => {
				if (this.tempCurrentImgIndex.curIndex + 1 === JSON.parse(res.remarks).page) {
					resArr.push(res)
				}
			})
			this.rectDetail = resArr
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/css/mark-point.less';
</style>
